import {
  responsiveConfig,
  useResponsive,
} from 'Components/hooks/use-responsive'

// 用于client获取header的高度，ssr场景不建议使用
export function getHeaderHeight() {
  if (typeof window === 'undefined') {
    throw new Error('call getHeaderHeight on the server side')
  }
  if (window.matchMedia(`(min-width: ${responsiveConfig['xl']}px)`).matches) {
    return 78 // xl
  } else if (
    window.matchMedia(`(min-width: ${responsiveConfig['lg']}px)`).matches
  ) {
    return 64 // lg
  } else {
    return 56 // sm
  }
}

function useHeaderHeight() {
  const { lg, xl } = useResponsive()
  if (xl) {
    return 78 // xl
  } else if (lg) {
    return 64 // lg
  } else {
    return 56 // sm
  }
}

export default useHeaderHeight
